var _rect, _circle, _circle2, _path, _path2, _text, _text2, _path3, _rect2, _circle3, _path4, _path5, _text3, _text4, _rect3, _text5, _rect4, _circle4, _path6, _text6, _text7, _rect5, _text8, _rect6, _circle5, _rect7, _path7, _text9, _text0, _rect8, _text1, _rect9, _circle6, _circle7, _path8, _text10, _text11, _rect0, _text12, _rect1, _circle8, _text13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportRoleBasedControlAccountabilityMapMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 620,
    height: 1170,
    viewBox: "0 0 620 1170",
    role: "img",
    "aria-label": "Role-based control mobile map",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 620,
    height: 1170,
    rx: 38,
    fill: "#07152A",
    stroke: "#29405D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 164,
    r: 100,
    fill: "#087CFF",
    fillOpacity: 0.1,
    stroke: "#1B5FA8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 164,
    r: 62,
    fill: "#0B1D35",
    stroke: "#30D6A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310 131.2l14.700000000000001 5.25v10.5c0 9.450000000000001-6.300000000000001 15.75-14.700000000000001 19.95-14.700000000000001-4.2-14.700000000000001-10.5-14.700000000000001-19.95v-10.5z",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M302.65 148l5.25 5.25 10.5-11.55",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.52,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 204,
    textAnchor: "middle",
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 17,
    fontWeight: 850
  }, "WORK PASSPORT")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 229,
    textAnchor: "middle",
    fill: "#9AB0CA",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 650
  }, "ONE GOVERNED SOURCE")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M310 266v76M310 558v48M310 822v48",
    stroke: "#29405D",
    strokeWidth: 3,
    strokeDasharray: "7 8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 352,
    width: 536,
    height: 154,
    rx: 24,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 429,
    r: 34,
    fill: "#087CFF",
    fillOpacity: 0.12
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101 415.88l11.479999999999999 4.1v8.2c0 7.38-4.92 12.299999999999999-11.479999999999999 15.579999999999998-11.479999999999999-3.28-11.479999999999999-8.2-11.479999999999999-15.579999999999998v-8.2z",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.9679999999999997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.26 429l4.1 4.1 8.2-9.02",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.9679999999999997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 414,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 22,
    fontWeight: 850
  }, "Compliance teams")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 447,
    fill: "#9AB0CA",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 650
  }, "Requirements, evidence and exceptions")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 465,
    width: 136,
    height: 25,
    rx: 12,
    fill: "#087CFF",
    fillOpacity: 0.12
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 168,
    y: 482,
    fill: "#087CFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "ROLE-BASED VIEW")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 550,
    width: 536,
    height: 154,
    rx: 24,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 627,
    r: 34,
    fill: "#30D6A1",
    fillOpacity: 0.12
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.52 637.66v-22.139999999999997h22.959999999999997v22.139999999999997M95.26 621.26h2.46m4.1 0h2.46m4.1 0h2.46M87.06 637.66h27.88",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 1.9679999999999997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 612,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 22,
    fontWeight: 850
  }, "Operations managers")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 645,
    fill: "#9AB0CA",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 650
  }, "Deployment readiness before allocation")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 663,
    width: 136,
    height: 25,
    rx: 12,
    fill: "#30D6A1",
    fillOpacity: 0.12
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 168,
    y: 680,
    fill: "#30D6A1",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "ROLE-BASED VIEW")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 748,
    width: 536,
    height: 154,
    rx: 24,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 825,
    r: 34,
    fill: "#F5AE35",
    fillOpacity: 0.12
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 89.52,
    y: 815.16,
    width: 22.959999999999997,
    height: 20.5,
    rx: 2.46,
    fill: "none",
    stroke: "#F5AE35",
    strokeWidth: 1.9679999999999997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.52 821.72h22.959999999999997M95.26 811.88v5.739999999999999M106.74 811.88v5.739999999999999",
    fill: "none",
    stroke: "#F5AE35",
    strokeWidth: 1.9679999999999997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 810,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 22,
    fontWeight: 850
  }, "Training coordinators")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 843,
    fill: "#9AB0CA",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 650
  }, "Cohorts, dates and delivery status")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 861,
    width: 136,
    height: 25,
    rx: 12,
    fill: "#F5AE35",
    fillOpacity: 0.12
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 168,
    y: 878,
    fill: "#F5AE35",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "ROLE-BASED VIEW")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 946,
    width: 536,
    height: 154,
    rx: 24,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 1023,
    r: 34,
    fill: "#F54291",
    fillOpacity: 0.12
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 1015.62,
    r: 4.92,
    fill: "none",
    stroke: "#F54291",
    strokeWidth: 1.9679999999999997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.34 1034.48c0-9.84 21.32-9.84 21.32 0",
    fill: "none",
    stroke: "#F54291",
    strokeWidth: 1.9679999999999997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 1008,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 22,
    fontWeight: 850
  }, "Employees")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 154,
    y: 1041,
    fill: "#9AB0CA",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 650
  }, "Due actions, session choices and passport")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 1059,
    width: 136,
    height: 25,
    rx: 12,
    fill: "#F54291",
    fillOpacity: 0.12
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 168,
    y: 1076,
    fill: "#F54291",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "ROLE-BASED VIEW")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 1072,
    width: 536,
    height: 62,
    rx: 18,
    fill: "#10243E"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 1103,
    r: 6,
    fill: "#30D6A1"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 1109,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 760
  }, "Human-governed \xB7 Intelligence-assisted")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportRoleBasedControlAccountabilityMapMobile);
export default __webpack_public_path__ + "static/media/work-passport-role-based-control-accountability-map-mobile.2a7495e7137fddd6c60475cfba9f8792.svg";
export { ForwardRef as ReactComponent };